import { render, staticRenderFns } from "./editActivitiesType.vue?vue&type=template&id=96b18bea"
import script from "./editActivitiesType.vue?vue&type=script&lang=js"
export * from "./editActivitiesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports